<template>
  <div class="flashcard">

    <div class="card align-left" v-bind:class="{ 'notFlipped': !flipped }">

      <Markdown class="front question" v-if="flashcard.pairs[index].a.type === 'Text'" :source="flashcard.pairs[index].a.content" :html="true"/>
      <img class="front image question" v-if="flashcard.pairs[index].a.type === 'Image'" :src="flashcard.pairs[index].a.content" />

      <Markdown class="back solution" v-if="flipped && flashcard.pairs[index].b.type === 'Text'" :source="flashcard.pairs[index].b.content" :html="true"/>
      <img class="back image" v-if="flipped && flashcard.pairs[index].b.type === 'Image'" :src="flashcard.pairs[index].b.content" />
      <Markdown class="back subtitle solution" v-if="flipped && flashcard.pairs[index].b.type === 'Text' && flashcard.pairs[index].b.subContent" :source="flashcard.pairs[index].b.subContent" :html="true"/>

      <p class="front subtitle" v-if="!flipped && flashcard.pairs[index].a.type === 'Text' && flashcard.pairs[index].a.subContent">...</p>

      <Markdown class="subtitle" v-if="flashcard.pairs[index].a.type === 'Text' && flashcard.pairs[index].a.subContent" :source="flashcard.pairs[index].a.subContent" :html="true"/>

    </div>

    <span v-if="!flipped" v-on:click="flipClicked" :class="flashcard.color + ' btn main-sized no-print'">Lösung</span>
    <span v-if="flipped" v-on:click="nextClicked" :class="flashcard.color + ' btn main-sized no-print'">Weiter</span>
  </div>
</template>

<style>

.flashcard .card.notFlipped > p:not(.subtitle) {
  border: none;
}

.flashcard .card > .solution, .flashcard .card > .subtitle, .flashcard .card > .question:not(.image) {
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.flashcard .card > .subtitle, .flashcard .card > .solution {
  border-top: 1px solid black;
}

.flashcard .btn {
  position: fixed;
  bottom: 0;
  padding: 0.5em;
  margin: auto;
  box-sizing: border-box;
  cursor: pointer;
  font-weight: bold;

  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

.flashcard .card .front.image, .flashcard .card .back.image {
  max-width: 100%;
}

</style>

<script>
import {reactive} from "vue";
import Markdown from 'vue3-markdown-it';

export default {
  name: 'FlashCardPart',
  props: ['part'],
  components: {
    Markdown
  },
  methods: {
    flipClicked() {
      this.flipped = true
      // console.log('#######', this)
    },
    nextClicked() {
      let nextIndex = this.index + 1
      if (nextIndex >= this.flashcard.pairs.length) {
        nextIndex = 0
      }
      this.index = nextIndex
      this.flipped = false
    }
  },
  async setup(props) {
    return {
      flashcard: reactive(await props.part.getFlashcard())
    }
  },
  data() {
    return {
      index: 0,
      flipped: false
    }
  }
}
</script>
